import { render } from "./IntegrationsComponent.vue?vue&type=template&id=00ba2056"
import script from "./IntegrationsComponent.vue?vue&type=script&lang=js"
export * from "./IntegrationsComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__